export const ProductImageStatus = {
  UPLOADING: 0,
  UPLOADED: 1,
  UPLOAD_FAILED: 2,
  SUBMITTED: 3,
};

export const productEditingModes = {
  ADD_NEW: 0,
  EDIT_EXISTING: 1,
  EXTENDED_EDIT_EXISTING: 2,
};
Object.freeze(productEditingModes);
